// extracted by mini-css-extract-plugin
export default {"TextContent":"filter-details_TextContent__psKti"};